import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { removeAll } from '@/utils/auth'
import serverUrl from '@/utils/GlobalPath.js'

axios.defaults.withCredentials = true
// import cookieBus from '@/utils/cookieBus.js'
// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.0.216:8080/app/mock/18', // api 的 base_url
  // baseURL: 'http://192.168.0.129:8080/cmsPortal', // api 的 base_url
  baseURL: serverUrl.serverUrl,
  // baseURL: process.env.BASE_API + 'WBP', // api 的 base_url
  timeout: 80000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    /* 处理post请求参数后台无法获取
   * (encodeURIComponent(config.params[it]) === 'null' ? '' : encodeURIComponent(config.params[it]))
   * 处理无参数null为""
   * */
    if (config.method === 'POST' || config.method === 'post') {
      if (!config.uploadBol) {
        config.headers['Content-type'] = 'application/x-www-form-urlencoded'
        let ret = ''
        for (const it in config.params) {
          ret += encodeURIComponent(it) + '=' + (encodeURIComponent(config.params[it]) === 'null' ? '' : encodeURIComponent(config.params[it])) + '&'
        }
        config.data = ret // /拼接参数
        config.params = ''
      }
    }
    // if (!config.data.headers) {
    //   config.data.headers = {}
    // }
    // config.data.headers.cookie = cookieBus.$cookie
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改, response.status为链接返回的回调，一样做报错处理
     */
    // console.log(response.headers['set-cookie'][0].JSESSIONID)
    // console.log(response.headers['set-cookie'][0])
    const res = response.data
    const resState = response.status
    if (res.code !== 200 || resState !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 1 * 1000
      })
      // 422 seesion过期了;
      if (res.code === 405 || resState === 405) {
        MessageBox.confirm(
          '您的用户信息已过期，您可以停留在当前页面或者重新登录',
          '提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          removeAll()
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: '出错啦：' + error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
